<template lang="pug">
  div.circle-loader-wrapper
    .circle-loader(:style="loaderStyle")
    slot(v-if="!noTitle")
      span {{$t('Загрузка')}}
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'circle-loader',
})
export default class CircleLoader extends Vue {
  @Prop({ default: '25px' })
  size!: string

  @Prop({ default: '#c4c4c4' })
  colorBackground!: string

  @Prop({ default: '#418f14' })
  color!: string

  @Prop({default: false})
  noTitle: boolean

  get loaderStyle() {
    return {
      width: this.size,
      height: this.size,
      border: `5px solid ${this.colorBackground}`,
      borderBottomColor: this.color,
    };
  }
}
</script>

<style scoped lang="less">

.circle-loader-wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto;
  grid-auto-flow: column;
  width: fit-content;
  align-items: center;
}

.circle-loader {
  //margin: 10px 0 0 0;
  //width: 25px;
  //height: 25px;
  //border: 5px solid #c4c4c4;
  //border-bottom-color: #418f14;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<i18n>
{
  "en": {
    "Загрузка": "Loading"
  }
}
</i18n>
